import {
    CollectionDataLoaded,
    ContentDataDefinitionLoader,
    createRegisterableComponentWithData,
} from '@news-mono/web-common'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import React, { useContext } from 'react'
import { CollectionDataContext } from '../../../contexts'
import {
    TopicSectionArticleCardList,
    TopicSectionArticleCardListProps,
} from './TopicSectionArticleCardList'

export const TopicSectionArticleCardListRegistration =
    createRegisterableComponentWithData(
        'topic-section-card-list',
        ContentDataDefinitionLoader,
        (
            {
                expectedItemCount,
                adUnits,
                adTargeting,
            }: Omit<
                TopicSectionArticleCardListProps,
                'items' | 'onEvent' | 'api' | 'adState'
            >,
            { dataDefinitionArgs, ...initialData },
            { onEvent, adState, config },
        ) => {
            const { getCollectionData } = useContext(CollectionDataContext)

            const contextId =
                dataDefinitionArgs.type === 'context'
                    ? dataDefinitionArgs.contextId
                    : undefined

            let data: MaybeLoaded<CollectionDataLoaded> = initialData
            if (contextId) {
                data = getCollectionData(contextId)
            }

            return (
                <TopicSectionArticleCardList
                    items={
                        data.loaded
                            ? {
                                  loaded: true,
                                  result: data.result.publications,
                              }
                            : { loaded: false }
                    }
                    adUnits={adUnits}
                    expectedItemCount={expectedItemCount}
                    onEvent={onEvent}
                    api={config.contentApi}
                    adState={adState}
                    isStandalonePage={true}
                    adTargeting={adTargeting}
                    config={config}
                />
            )
        },
    )
